import get from 'lodash/get';
import { ContentItem } from 'kentico-cloud-delivery';

export default class GlobalMetaTag extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get name() {
    return get(this, '_name.value', '');
  }

  get content() {
    return get(this, '_content.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/GlobalMetaTag.js